import React from 'react';

// ContractForm - Multi-step contract creation form
// This is a placeholder for the complex multi-step form
// Full implementation will include:
// Step 1: Basic contract info (number, title, territory, dates)
// Step 2: Select licensor
// Step 3: Select licensees
// Step 4: Select IP objects with rights categories
// Step 5: Review and submit

const ContractForm = ({ contractId = null }) => {
  const isEditMode = !!contractId;

  return (
    <div className="contract-form-container">
      <div className="form-header">
        <h1>{isEditMode ? 'Edit Contract' : 'New Contract'}</h1>
        <a href="/contracts" className="btn btn-secondary">Cancel</a>
      </div>

      <div className="placeholder-message">
        <h2>Contract Form</h2>
        <p>
          The contract creation form will be a multi-step wizard including:
        </p>
        <ol>
          <li>Basic contract information (contract number, title, territory, dates)</li>
          <li>Licensor selection</li>
          <li>Licensee selection</li>
          <li>IP object and rights category selection</li>
          <li>Review and confirmation</li>
        </ol>
        <p>
          For now, please use the API endpoint directly or the Rails console to create contracts.
        </p>
        <div className="api-example">
          <h3>API Example:</h3>
          <pre>{`POST /api/v1/contracts
Content-Type: application/json

{
  "contract": {
    "contract_number": "CNT-2025-001",
    "title": "Contract Title",
    "description": "Contract description",
    "territory_id": 1,
    "status": "draft",
    "start_date": "2025-01-01",
    "end_date": "2027-12-31",
    "licensor_id": 1,
    "licensee_ids": [2, 3],
    "ip_object_assignments": [
      {
        "ip_object_id": 1,
        "rights_category_id": 1,
        "sublicense_permitted": false,
        "field_of_use": "Merchandise",
        "effective_date": "2025-01-01",
        "termination_date": "2027-12-31"
      }
    ]
  }
}`}</pre>
        </div>
        <a href="/contracts" className="btn btn-primary">Back to Contracts</a>
      </div>

      <style jsx>{`
        .contract-form-container {
          padding: 20px;
          max-width: 900px;
          margin: 0 auto;
        }

        .form-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
        }

        .placeholder-message {
          background: white;
          border: 1px solid #ddd;
          border-radius: 8px;
          padding: 40px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .placeholder-message h2 {
          margin: 0 0 20px 0;
          color: #333;
        }

        .placeholder-message p {
          color: #666;
          line-height: 1.6;
          margin-bottom: 15px;
        }

        .placeholder-message ol {
          margin: 20px 0;
          padding-left: 25px;
          color: #666;
        }

        .placeholder-message li {
          margin-bottom: 10px;
        }

        .api-example {
          margin: 30px 0;
          padding: 20px;
          background: #f9fafb;
          border-radius: 6px;
        }

        .api-example h3 {
          margin: 0 0 15px 0;
          font-size: 16px;
          color: #333;
        }

        .api-example pre {
          background: #1e293b;
          color: #e2e8f0;
          padding: 20px;
          border-radius: 6px;
          overflow-x: auto;
          font-size: 13px;
          line-height: 1.6;
        }

        .btn {
          padding: 10px 20px;
          border: 1px solid #ddd;
          border-radius: 4px;
          background: white;
          color: #333;
          text-decoration: none;
          cursor: pointer;
          font-size: 14px;
          display: inline-block;
          transition: all 0.2s;
        }

        .btn:hover {
          background: #f5f5f5;
        }

        .btn-primary {
          background: #2563eb;
          color: white;
          border-color: #2563eb;
        }

        .btn-primary:hover {
          background: #1d4ed8;
        }

        .btn-secondary {
          background: #6b7280;
          color: white;
          border-color: #6b7280;
        }

        .btn-secondary:hover {
          background: #4b5563;
        }
      `}</style>
    </div>
  );
};

export default ContractForm;
